import React, { useState, useEffect } from "react";
import Aside from "../common/Asside";
import Header from "../common/Header";

function Home() {
  // State to track the visibility of each section
  const [visibleSections, setVisibleSections] = useState({
    registeredUsers: true,
    firstDeposit: true,
    deposit: true,
    withdrawal: true,
    bonus: true,
    vipCashBonus: true,
    referralCommission: true,
    turnover: true,
    affiliateProfitLoss: true,
  });

  const [data, setData] = useState(null);
  const[deductionRate, setDeductionRate] = useState(0);
  const [loading, setLoading] = useState(true);

  // Fetch data from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');

        const response = await fetch("https://esgaming.online/api/afiiliateindex", {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const result = await response.json();
        setData(result);

        const deductionRateStr = result?.profit_and_loss?.this_month?.deductionRate || "0.00";
        const deductionRateing = parseFloat(deductionRateStr.replace(/,/g, "") || 0);
        setDeductionRate(deductionRateing);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Stop loading after fetch completes
      }
    };

    fetchData();
  }, []);

  // Toggle function to update visibility for each section
  const toggleSection = (section) => {
    setVisibleSections((prevSections) => ({
      ...prevSections,
      [section]: !prevSections[section],
    }));
  };

  

  return (
    <div>
       <div>
      {loading ? (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
          <div
            className="blockUI blockMsg blockElement"
            style={{
              zIndex: 10010,
              position: 'absolute',
              padding: '15px',
              margin: '0px',
              width: '30%',
              textAlign: 'center',
              color: 'rgb(255, 255, 255)',
              border: 'none',
              backgroundColor: 'rgb(0, 0, 0)',
              cursor: 'default',
              borderRadius: '10px',
              opacity: '0.493912'
            }}
          >
            Loading...
          </div>
          <div className="modal-backdrop fade active"></div>
        </div>
      ) : (
        <div>
         
        </div>
      )}
    </div>
     
   
   
      <Header />
      <div className="container-flex">
        <Aside />
        <div className="main">
          <div className="page-content">
            <div className="main-inner">
              <div className="page-content-body" style={{ display: "block" }}>
              <div className="col-wrap panel-group">
                  {/* Commission Section */}
                  <div className="section col-2 panel">
                    <div className="section-body">
                      <h4>Commission</h4>
                      <div className="float-right">
                        <div className="form-group">
                          <h4>This Period</h4>
                          <p className="number" id="thisPeriodCommission">
                            {(() => {
                              const commissionStr = data?.profit_and_loss?.this_month?.commission || "0.00";
                              const transactionStr = data?.profit_and_loss?.this_month?.transactionAmount || "0.00";
                              const lastcommissionStr = data?.profit_and_loss?.last_month?.commission || "0.00";
                              const lasttransactionStr = data?.profit_and_loss?.last_month?.transactionAmount || "0.00";
                              const lastcommission = parseFloat(lastcommissionStr.replace(/,/g, "") || 0);
                              const lasttransaction = parseFloat(lasttransactionStr.replace(/,/g, "") || 0);
                              const ccommssionRate = data?.profit_and_loss?.last_month?.commssionRate || "0.00";
                              const commission = parseFloat(commissionStr.replace(/,/g, "") || 0);
                              const transaction = parseFloat(transactionStr.replace(/,/g, "") || 0);
                              const deduction = commission * deductionRate;

                              const lastComssion = lastcommission - lasttransaction;
                              const finalComssion = lastComssion < 0 ? commission + lastComssion  : commission;

                              const netCommission = finalComssion - deduction - transaction;
                              const totalNetCommission =  netCommission * ccommssionRate; 
                              return totalNetCommission  > 0 ? (totalNetCommission).toFixed(2) : "0.00";
                            })()}
                          </p>
                        </div>
                        <div className="form-group">
                          <h4>Last Period</h4>
                          <p className="number" id="lastPeriodCommission">
                          {(() => {
                              const commissionStr = data?.profit_and_loss?.last_month?.commission || "0.00";
                              const transactionStr = data?.profit_and_loss?.last_month?.transactionAmount || "0.00";
                              const lastcommissionStr = data?.profit_and_loss?.month_before_last?.commission || "0.00";
                              const lasttransactionStr = data?.profit_and_loss?.month_before_last?.transactionAmount || "0.00";
                              const ccommssionRate = data?.profit_and_loss?.last_month?.commssionRate || "0.00";
                              const commission = parseFloat(commissionStr.replace(/,/g, "") || 0);
                              const transaction = parseFloat(transactionStr.replace(/,/g, "") || 0);
                              const lastcommission = parseFloat(lastcommissionStr.replace(/,/g, "") || 0);
                              const lasttransaction = parseFloat(lasttransactionStr.replace(/,/g, "") || 0);
                              const deduction = commission * deductionRate;
                              const lastComssion = lastcommission - lasttransaction ;
                              const finalComssion = commission + lastComssion;
                              const netCommission = finalComssion - deduction - transaction;
                              const totalNetCommission =  netCommission * ccommssionRate;                       
                              return totalNetCommission  > 0 ? (totalNetCommission).toFixed(2) : "0.00";
                            })()}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Active Players Section */}
                  <div className="section col-2 panel">
                    <div className="section-body">
                      <h4>Active Players</h4>
                      <div className="float-right">
                        <div className="form-group">
                          <h4>This Period</h4>
                          <p className="number" id="thisPeriodActivePlayer">
                            {data?.profit_and_loss?.this_month?.activePlayerCounts || 0}
                          </p>
                        </div>
                        <div className="form-group">
                          <h4>Last Period</h4>
                          <p className="number" id="lastPeriodActivePlayer">
                          {data?.profit_and_loss?.last_month?.activePlayerCounts || 0}

                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-wrap">
                  <div className="section col-2 panel" id="section_5">
                    <div className="section-head">
                      <h2 className="title">Registered Users</h2>
                      <button
                        className="btn-ic-grey dropdown-toggle"
                        onClick={() => toggleSection("registeredUsers")}
                      />
                    </div>
                    <div className={`section-body ${visibleSections.registeredUsers ? "d-block" : "d-none"}`}>
                      <table className="table table-striped">
                        <thead className="thead-light">
                          <tr>
                            <th>Period</th>
                            <th>Count</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="align-center">Today</td>
                            <td>{data?.registered_users?.today || 0}</td>
                          </tr>
                          <tr>
                            <td className="align-center">Yesterday</td>
                            <td>{data?.registered_users?.yesterday || 0}</td>
                          </tr>
                          <tr>
                            <td className="align-center">This Week</td>
                            <td>{data?.registered_users?.this_week || 0}</td>
                          </tr>
                          <tr>
                            <td className="align-center">Last Week</td>
                            <td>{data?.registered_users?.last_week || 0}</td>
                          </tr>
                          <tr>
                            <td className="align-center">This Month</td>
                            <td>{data?.registered_users?.this_month || 0}</td>
                          </tr>
                          <tr>
                            <td className="align-center">Last Month</td>
                            <td>{data?.registered_users?.last_month || 0}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* Repeat similar structure for other sections */}
                  {/* First Deposit Section */}
                  <div className="section col-2 panel" id="section_4">
                    <div className="section-head">
                      <h2 className="title">First Deposit</h2>
                      <button
                        className="btn-ic-grey dropdown-toggle"
                        onClick={() => toggleSection("firstDeposit")}
                      />
                    </div>
                    <div className={`section-body ${visibleSections.firstDeposit ? "d-block" : "d-none"}`}>
                      <table className="table table-striped">
                        <thead className="thead-light">
                          <tr>
                            <th>Period</th>
                            <th>Count</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="align-center">Today</td>
                            <td>{data?.first_deposits?.today?.count || 0}</td>
                            <td>{data?.first_deposits?.today?.sum || "0.00"}</td>
                          </tr>
                          <tr>
                            <td className="align-center">Yesterday</td>
                            <td>{data?.first_deposits?.yesterday?.count || 0}</td>
                            <td>{data?.first_deposits?.yesterday?.sum || "0.00"}</td>
                          </tr>
                          <tr>
                            <td className="align-center">This Week</td>
                            <td>{data?.first_deposits?.this_week?.count || 0}</td>
                            <td>{data?.first_deposits?.this_week?.sum || "0.00"}</td>
                          </tr>
                          <tr>
                            <td className="align-center">Last Week</td>
                            <td>{data?.first_deposits?.last_week?.count || 0}</td>
                            <td>{data?.first_deposits?.last_week?.sum || "0.00"}</td>
                          </tr>
                          <tr>
                            <td className="align-center">This Month</td>
                            <td>{data?.first_deposits?.this_month?.count || 0}</td>
                            <td>{data?.first_deposits?.this_month?.sum || "0.00"}</td>
                          </tr>
                          <tr>
                            <td className="align-center">Last Month</td>
                            <td>{data?.first_deposits?.last_month?.count || 0}</td>
                            <td>{data?.first_deposits?.last_month?.sum || "0.00"}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  
                </div>
                <div className="col-wrap"> 
                  {/* Deposit Section */}
                <div className="section col-2 panel" id="section_2">
                  <div className="section-head">
                    <h2 className="title">Deposit</h2>
                    <button
                      className="btn-ic-grey dropdown-toggle"
                      onClick={() => toggleSection("deposit")}
                    />
                  </div>
                  <div className={`section-body ${visibleSections.deposit ? "d-block" : "d-none"}`}>
                    <table className="table table-striped">
                      <thead className="thead-light">
                        <tr>
                          <th>Period</th>
                          <th>Count</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-center">Today</td>
                          <td>{data?.deposits?.today?.count || 0}</td>
                          <td>{data?.deposits?.today?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Yesterday</td>
                          <td>{data?.deposits?.yesterday?.count || 0}</td>
                          <td>{data?.deposits?.yesterday?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Week</td>
                          <td>{data?.deposits?.this_week?.count || 0}</td>
                          <td>{data?.deposits?.this_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Week</td>
                          <td>{data?.deposits?.last_week?.count || 0}</td>
                          <td>{data?.deposits?.last_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Month</td>
                          <td>{data?.deposits?.this_month?.count || 0}</td>
                          <td>{data?.deposits?.this_month?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Month</td>
                          <td>{data?.deposits?.last_month?.count || 0}</td>
                          <td>{data?.deposits?.last_month?.sum || "0.00"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Withdrawal Section */}
                <div className="section col-2 panel" id="section_3">
                  <div className="section-head">
                    <h2 className="title">Withdrawal</h2>
                    <button
                      className="btn-ic-grey dropdown-toggle"
                      onClick={() => toggleSection("withdrawal")}
                    />
                  </div>
                  <div className={`section-body ${visibleSections.withdrawal ? "d-block" : "d-none"}`}>
                    <table className="table table-striped">
                      <thead className="thead-light">
                        <tr>
                          <th>Period</th>
                          <th>Count</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-center">Today</td>
                          <td>{data?.withdrawals?.today?.count || 0}</td>
                          <td>{data?.withdrawals?.today?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Yesterday</td>
                          <td>{data?.withdrawals?.yesterday?.count || 0}</td>
                          <td>{data?.withdrawals?.yesterday?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Week</td>
                          <td>{data?.withdrawals?.this_week?.count || 0}</td>
                          <td>{data?.withdrawals?.this_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Week</td>
                          <td>{data?.withdrawals?.last_week?.count || 0}</td>
                          <td>{data?.withdrawals?.last_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Month</td>
                          <td>{data?.withdrawals?.this_month?.count || 0}</td>
                          <td>{data?.withdrawals?.this_month?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Month</td>
                          <td>{data?.withdrawals?.last_month?.count || 0}</td>
                          <td>{data?.withdrawals?.last_month?.sum || "0.00"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                </div>
                <div className="col-wrap">
                  {/* Bonus Section */}
                <div className="section col-2 panel" id="section_0">
                  <div className="section-head">
                    <h2 className="title">Bonus</h2>
                    <button
                      className="btn-ic-grey dropdown-toggle"
                      onClick={() => toggleSection("bonus")}
                    />
                  </div>
                  <div className={`section-body ${visibleSections.bonus ? "d-block" : "d-none"}`}>
                    <table className="table table-striped">
                      <thead className="thead-light">
                        <tr>
                          <th>Period</th>
                          <th>Count</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-center">Today</td>
                          <td>{data?.bonuses?.today?.count || 0}</td>
                          <td>{data?.bonuses?.today?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Yesterday</td>
                          <td>{data?.bonuses?.yesterday?.count || 0}</td>
                          <td>{data?.bonuses?.yesterday?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Week</td>
                          <td>{data?.bonuses?.this_week?.count || 0}</td>
                          <td>{data?.bonuses?.this_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Week</td>
                          <td>{data?.bonuses?.last_week?.count || 0}</td>
                          <td>{data?.bonuses?.last_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Month</td>
                          <td>{data?.bonuses?.this_month?.count || 0}</td>
                          <td>{data?.bonuses?.this_month?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Month</td>
                          <td>{data?.bonuses?.last_month?.count || 0}</td>
                          <td>{data?.bonuses?.last_month?.sum || "0.00"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* VIP Cash Bonus Section */}
                <div className="section col-2 panel" id="section_13">
                  <div className="section-head">
                    <h2 className="title">VIP Cash Bonus</h2>
                    <button
                      className="btn-ic-grey dropdown-toggle"
                      onClick={() => toggleSection("vipCashBonus")}
                    />
                  </div>
                  <div className={`section-body ${visibleSections.vipCashBonus ? "d-block" : "d-none"}`}>
                    <table className="table table-striped">
                      <thead className="thead-light">
                        <tr>
                          <th>Period</th>
                          <th>Count</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-center">Today</td>
                          <td>{data?.vipbonuses?.today?.count || 0}</td>
                          <td>{data?.vipbonuses?.today?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Yesterday</td>
                          <td>{data?.vipbonuses?.yesterday?.count || 0}</td>
                          <td>{data?.vipbonuses?.yesterday?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Week</td>
                          <td>{data?.vipbonuses?.this_week?.count || 0}</td>
                          <td>{data?.vipbonuses?.this_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Week</td>
                          <td>{data?.vipbonuses?.last_week?.count || 0}</td>
                          <td>{data?.vipbonuses?.last_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Month</td>
                          <td>{data?.vipbonuses?.this_month?.count || 0}</td>
                          <td>{data?.vipbonuses?.this_month?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Month</td>
                          <td>{data?.vipbonuses?.last_month?.count || 0}</td>
                          <td>{data?.vipbonuses?.last_month?.sum || "0.00"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                </div>
                <div className="col-wrap">
                  {/* Referral Commission Section */}
                <div className="section col-2 panel" id="section_15">
                  <div className="section-head">
                    <h2 className="title">Referral Commission</h2>
                    <button
                      className="btn-ic-grey dropdown-toggle"
                      onClick={() => toggleSection("referralCommission")}
                    />
                  </div>
                  <div className={`section-body ${visibleSections.referralCommission ? "d-block" : "d-none"}`}>
                    <table className="table table-striped">
                      <thead className="thead-light">
                        <tr>
                          <th>Period</th>
                          <th>Count</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-center">Today</td>
                          <td>{data?.refcommissions?.today?.count || 0}</td>
                          <td>{data?.refcommissions?.today?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Yesterday</td>
                          <td>{data?.refcommissions?.yesterday?.count || 0}</td>
                          <td>{data?.refcommissions?.yesterday?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Week</td>
                          <td>{data?.refcommissions?.this_week?.count || 0}</td>
                          <td>{data?.refcommissions?.this_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Week</td>
                          <td>{data?.refcommissions?.last_week?.count || 0}</td>
                          <td>{data?.refcommissions?.last_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Month</td>
                          <td>{data?.refcommissions?.this_month?.count || 0}</td>
                          <td>{data?.refcommissions?.this_month?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Month</td>
                          <td>{data?.refcommissions?.last_month?.count || 0}</td>
                          <td>{data?.refcommissions?.last_month?.sum || "0.00"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Turnover Section */}
                <div className="section col-2 panel" id="section_6">
                  <div className="section-head">
                    <h2 className="title">Turnover</h2>
                    <button
                      className="btn-ic-grey dropdown-toggle"
                      onClick={() => toggleSection("turnover")}
                    />
                  </div>
                  <div className={`section-body ${visibleSections.turnover ? "d-block" : "d-none"}`}>
                    <table className="table table-striped">
                      <thead className="thead-light">
                        <tr>
                          <th>Period</th>
                          <th>Count</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-center">Today</td>
                          <td>{data?.turnovers?.today?.count || 0}</td>
                          <td>{data?.turnovers?.today?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Yesterday</td>
                          <td>{data?.turnovers?.yesterday?.count || 0}</td>
                          <td>{data?.turnovers?.yesterday?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Week</td>
                          <td>{data?.turnovers?.this_week?.count || 0}</td>
                          <td>{data?.turnovers?.this_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Week</td>
                          <td>{data?.turnovers?.last_week?.count || 0}</td>
                          <td>{data?.turnovers?.last_week?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">This Month</td>
                          <td>{data?.turnovers?.this_month?.count || 0}</td>
                          <td>{data?.turnovers?.this_month?.sum || "0.00"}</td>
                        </tr>
                        <tr>
                          <td className="align-center">Last Month</td>
                          <td>{data?.turnovers?.last_month?.count || 0}</td>
                          <td>{data?.turnovers?.last_month?.sum || "0.00"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                </div>
                <div className="col-wrap">
  {/* Affiliate Profit & Loss Section */}
  <div className="section col-1 panel" id="section_1">
  <div className="section-head">
    <h2 className="title">Affiliate Profit & Loss</h2>
    <button
      className="btn-ic-grey dropdown-toggle"
      onClick={() => toggleSection("affiliateProfitLoss")}
    />
  </div>
  <div className={`section-body ${visibleSections.affiliateProfitLoss ? "d-block" : "d-none"}`}>
    <table className="table table-striped">
      <thead className="thead-light">
        <tr>
          <th>Period</th>
          <th>Count</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
            {["today", "yesterday", "this_week", "last_week", "this_month", "last_month"].map((period) => {
              const lossAmount = parseFloat(data?.profit_and_loss?.[period]?.loss?.amount || 0);
              const profitAmount = parseFloat(data?.profit_and_loss?.[period]?.profit?.amount || 0);
              const lossAmountCount = parseFloat(data?.profit_and_loss?.[period]?.loss?.count || 0);
              const profitAmountCount = parseFloat(data?.profit_and_loss?.[period]?.profit?.count || 0);
                          // Logic for calculating total profit
                          const totalProfit = profitAmount - lossAmount;
                          const totalProfitCount = profitAmountCount - lossAmountCount;
                          const isLoss = totalProfit < 0;
                          const isLossCount = totalProfitCount < 0;
                          const formattedAmount = (amount) =>
                            new Intl.NumberFormat('en-US', {
                              style: 'decimal',
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(amount);
                            return (
                              <tr key={period}>
                                <td className="align-center">
                                  {period.replace("_", " ").replace(/\b\w/g, c => c.toUpperCase())}
                                </td>
                                <td>0</td>
                                <td style={{ color: isLoss ? "red" : "inherit" }}>
                                  {isLoss ? `${formattedAmount(Math.abs(totalProfit))}` : ` ${formattedAmount(Math.abs(totalProfit))}`}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>

    </table>
  </div>
</div>

</div>


              </div>
            </div>
            <footer className="footer">Copyright © 2024. All rights Reserved</footer>
            <div className="modal-backdrop fade" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
